import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { formatInTimeZone } from 'date-fns-tz'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const PackageStatusInfo = ({
  buildingSmsPackage,
  isBuildingSmsPackageActive,
  isBuildingSmsPackageNeedLoad,
  timezone,
  tooltipInfo,
}) => {
  const { t } = useTranslation(['chat'])
  if (!buildingSmsPackage) {
    return (
      <div className="package-status-container">
        <div className="package-status-text">
          {t('chat:packageStatusInfo.noActiveSubscription')}
        </div>
        <span data-tip data-for="triggerTip" style={{ paddingTop: 5 }}>
          <Icon icon="exclamationPoint" />
          <ReactTooltip
            className="tooltip"
            id="triggerTip"
            multiline={true}
            place="top"
            effect="solid"
          >
            {tooltipInfo()}
          </ReactTooltip>
        </span>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="section-title">
        {isBuildingSmsPackageActive ? (
          t('chat:packageStatusInfo.activePackage')
        ) : (
          <span className="not-active">
            <Icon icon="exclamationPoint" />
            {buildingSmsPackage.endDate
              ? t('chat:packageStatusInfo.subscriptionCancelledEndDate', {
                  date: formatInTimeZone(buildingSmsPackage.endDate, timezone, 'MM/dd/yyyy'),
                })
              : t('chat:packageStatusInfo.subscriptionCancelledNoDate')}
          </span>
        )}
      </div>
      <div className="package-status-container">
        <div className="package-status-text">
          {t('chat:packageStatusInfo.smsPackage')}{' '}
          <span
            className={`package-status-color ${
              isBuildingSmsPackageNeedLoad ? 'below-average' : 'above-average'
            }`}
          >
            {buildingSmsPackage.remainingSmsCredit} {t('chat:packageStatusInfo.smsLeft')}
          </span>
        </div>
        <span data-tip data-for="triggerTip" style={{ paddingTop: 5 }}>
          <Icon icon="exclamationPoint" />
          <ReactTooltip
            className="tooltip"
            id="triggerTip"
            multiline={true}
            place="top"
            effect="solid"
          >
            {tooltipInfo()}
          </ReactTooltip>
        </span>
      </div>
    </React.Fragment>
  )
}

PackageStatusInfo.propTypes = {
  buildingSmsPackage: PropTypes.shape({
    endDate: PropTypes.string,
    remainingSmsCredit: PropTypes.number,
  }),
  isBuildingSmsPackageActive: PropTypes.bool,
  isBuildingSmsPackageNeedLoad: PropTypes.bool,
  timezone: PropTypes.string.isRequired,
  tooltipInfo: PropTypes.func.isRequired,
}

export default PackageStatusInfo
